<template>
  <div class="privacy-policy">
    <h1>Politique de Confidentialité</h1>

    <section>
      <h2>Introduction</h2>
      <p>
        Face au développement des nouvelles technologies de communication, il est essentiel de protéger la vie privée.
        C'est pourquoi <strong>Gwassou</strong> s'engage à respecter et protéger la confidentialité des informations personnelles que nous collectons.
      </p>
      <p>
        Cette politique décrit les types d'informations que nous collectons, leur utilisation, leur partage, et vos droits concernant vos données personnelles.
      </p>
    </section>

    <section>
      <h2>Collecte des Renseignements Personnels</h2>
      <p>
        Nous collectons et utilisons les informations suivantes :
      </p>
      <ul>
        <li>Nom et prénom.</li>
        <li>Numéro de téléphone.</li>
        <li>Adresse email.</li>
        <li>Date de naissance.</li>
        <li>Données de localisation (GPS) collectées lors de l’utilisation du scanner QR.</li>
        <li>Photos des utilisateurs (capturées avec leur consentement).</li>
        <li>Accès à la caméra de l'appareil pour scanner les codes QR.</li>
      </ul>
      <p>
        Ces informations sont collectées pour fournir les fonctionnalités principales de l'application Gwassou, telles que :
      </p>
      <ul>
        <li>L'identification des utilisateurs.</li>
        <li>La lecture des codes QR pour des interactions sécurisées.</li>
        <li>La vérification de la validité des bons en fonction de la proximité géographique.</li>
        <li>La gestion des services associés à votre compte utilisateur.</li>
      </ul>
    </section>

    <section>
      <h2>Utilisation des Informations Personnelles</h2>
      <p>
        Les informations collectées sont utilisées uniquement pour :
      </p>
      <ul>
        <li>Scanner les codes QR pour activer des fonctionnalités spécifiques de l'application.</li>
        <li>Vérifier la validité des bons en se basant sur leur date, leur statut et votre position géographique.</li>
        <li>Stocker temporairement les photos des utilisateurs à des fins strictement liées à leur usage au sein de l'application.</li>
        <li>Assurer la gestion de votre compte et des services personnalisés.</li>
      </ul>
      <p>
        Nous n'utiliserons pas vos informations personnelles à des fins commerciales ou publicitaires sans votre consentement explicite.
      </p>
    </section>

    <section>
      <h2>Protection des Données</h2>
      <p>
        Gwassou utilise des mesures de sécurité avancées pour protéger vos informations personnelles contre l'accès non autorisé, la perte ou l'altération.
      </p>
      <p>
        Les données personnelles collectées sont conservées uniquement pendant la durée nécessaire à leur traitement et sont supprimées ou anonymisées après cette période.
      </p>
    </section>

    <section>
      <h2>Données de Localisation</h2>
      <p>
        Pendant l'utilisation du scanner QR, l'application peut collecter votre position géographique (coordonnées GPS). Ces données sont utilisées uniquement pour :
      </p>
      <ul>
        <li>Localiser la station qui effectue la transaction.</li>
        <li>Améliorer la précision et la sécurité des opérations de validation.</li>
      </ul>
      <p>
        Les données de localisation sont conservées pendant la durée de la session et sont automatiquement supprimées à la fermeture de l'application.
      </p>
    </section>

    <section>
      <h2>Vos Droits</h2>
      <p>Vous disposez des droits suivants :</p>
      <ul>
        <li>Accéder à vos informations personnelles et en obtenir une copie.</li>
        <li>Demander la correction ou la mise à jour de vos données.</li>
        <li>Contester l'utilisation de vos informations personnelles.</li>
        <li>Demander la suppression de vos informations personnelles, y compris les données de localisation, en supprimant votre compte utilisateur.</li>
      </ul>
      <p>
        Pour exercer vos droits, veuillez nous contacter à <a href="mailto:contact@gwassou.com">contact@gwassou.com</a>.
      </p>
    </section>

    <section>
      <h2>Mises à Jour et Contact</h2>
      <p>
        Cette politique de confidentialité peut être mise à jour pour refléter les changements législatifs ou techniques. Nous vous encourageons à consulter cette page régulièrement.
      </p>
      <p>
        Si vous avez des questions ou des préoccupations, veuillez nous contacter à <a href="mailto:contact@gwassou.com">contact@gwassou.com</a>.
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
};
</script>

<style scoped>
.privacy-policy {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
  line-height: 1.6;
}
.privacy-policy h1 {
  font-size: 2em;
  margin-bottom: 0.5em;
}
.privacy-policy h2 {
  font-size: 1.5em;
  margin-top: 1.5em;
  margin-bottom: 0.5em;
}
.privacy-policy p {
  margin-bottom: 1em;
}
.privacy-policy ul {
  margin: 1em 0;
  padding-left: 1.5em;
}
.privacy-policy ul li {
  margin-bottom: 0.5em;
}
</style>